import React from 'react';
import { Button } from '@mui/material';

const UpdateOfferButton = ({ onUpdate, disabled = false }) => {
  if (!onUpdate) return null;

  return (
    <Button
      color="primary"
      variant="contained"
      onClick={() => onUpdate()}
      disabled={disabled}
      sx={{
        minHeight: 40,
        px: 2.5,
      }}
    >
      Update offer
    </Button>
  );
};

export default UpdateOfferButton;
